import { Search, PenLine, Wrench, LineChart } from "lucide-react";
import Reveal from "@/components/Reveal";

const DEFAULT_STEPS = [
  { icon: Search, title: "Discover", copy: "We understand your business, goals and current challenges.", tint: "#DDF2E7" },
  { icon: PenLine, title: "Shape", copy: "We create the strategy, structure and priorities.", tint: "#FFF1C9" },
  { icon: Wrench, title: "Build", copy: "We create, build or implement what's needed, whether that's content, systems, websites or AI.", tint: "#E3EEFF" },
  { icon: LineChart, title: "Support", copy: "We review, refine and support your marketing as your business evolves.", tint: "#ECE9FF" },
];

export const HowWeWork = ({ buildCopy, supportCopy, supportTitle } = {}) => {
  const STEPS = DEFAULT_STEPS.map((s) => {
    if (s.title === "Build" && buildCopy) return { ...s, copy: buildCopy };
    if (s.title === "Support") return {
      ...s,
      title: supportTitle || s.title,
      copy: supportCopy || s.copy,
    };
    return s;
  });
  return (
    <section data-testid="how-we-work" className="py-16 md:py-24 bg-[#fafafa]">
      <div className="td-container">
        <Reveal>
          <span className="td-label block mb-4">How We Work</span>
          <h2 className="text-3xl md:text-5xl font-semibold max-w-2xl leading-[1.1] text-black">
            A calm, collaborative process.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {STEPS.map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal key={step.title} delay={i * 90}>
                <div className="rounded-3xl p-8 h-full" style={{ background: step.tint }}>
                  <div className="flex items-center justify-between mb-8">
                    <span className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center shadow-sm">
                      <Icon size={22} className="text-[#1a1a1a]" strokeWidth={2} />
                    </span>
                    <span className="font-head text-4xl text-black/10">0{i + 1}</span>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-black">{step.title}</h3>
                  <p className="text-[15px] leading-relaxed text-[#4a4a55]">{step.copy}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
